export { default as OpeningLite } from './opening-lite';
